

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class ServiceChargeRuleFormat_ManagedObject

class ServiceChargeRuleFormat_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: serviceChargeFormat
    set serviceChargeFormat(value:string) {
        this.setValueForKey(value, 'serviceChargeFormat');
    }
    get serviceChargeFormat():string {
        return this.valueForKey('serviceChargeFormat');
    }
    set serviceChargeFormatPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'serviceChargeFormat');
    }
    get serviceChargeFormatPrimitiveValue():string {
        return this.primitiveValueForKey('serviceChargeFormat');
    }
    // Relationship: serviceChargeRule
    set serviceChargeRule(value:ServiceChargeRule) {
        this.setValueForKey(value, 'serviceChargeRule');
    }
    get serviceChargeRule():ServiceChargeRule {
        return this.valueForKey('serviceChargeRule') as ServiceChargeRule;
    }
    // Relationship: tag
    set tag(value:ServiceChargeTag) {
        this.setValueForKey(value, 'tag');
    }
    get tag():ServiceChargeTag {
        return this.valueForKey('tag') as ServiceChargeTag;
    }
}
